<template>
  <div>
    <v-widget title="Lịch sử thanh toán">
      <template v-slot:widget-header-action>
        <v-btn
          v-if="canPay"
          color="success"
          small
          @click="openDialog"
        >
          Thanh toán
        </v-btn>
      </template>
      <template v-slot:widget-content>
        <v-data-table
          :headers="paymentHistoryHeader"
          :items="order.PaymentHistory"
          :mobile-breakpoint="100"
          :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50] }"
          :items-per-page="10"
          class="border"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.CreatedDate | display_date }}</td>
              <td :style="{ color: get_type_color(item.Status, payment_status) }">
                {{ item.Status | display_value(payment_status) }}
              </td>
              <td>{{ item.Type | payment_method }}</td>
              <td>{{ item.Note }}</td>
              <td class="text-end font-weight-bold primary--text">{{ item.Amount | currency }}</td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </v-widget>

    <v-dialog v-model="dialogPayment" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Tạo thanh toán cho đơn hàng #{{ order.ID }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex xs12>
                <h-currency-input
                  v-model="paymentForm.Amount"
                  label="Số tiền"
                  :decimal="0"
                  required
                ></h-currency-input>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-model="paymentForm.Status"
                  :items="paymentTypes"
                  item-text="name"
                  item-value="value"
                  label="Loại thanh toán"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-model="paymentForm.Type"
                  :items="paymentMethods"
                  item-text="name"
                  item-value="value"
                  label="Hình thức thanh toán"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="paymentForm.Note"
                  label="Nội dung"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="closeDialog">Hủy</v-btn>
          <v-btn color="success darken-1 white--text" @click="savePayment" :loading="saving">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import configs from "@/configs";
import { request_header } from "@/commons/hpod";
import { sendErrorNotice, sendSuccessNotice } from "@/commons/utils";

export default {
  name: "TabPaymentHistory",
  components: {
    VWidget
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    paymentHistoryHeader: {
      type: Array,
      required: true
    },
    canPay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      payment_status: configs.PAYMENT_STATUS_LIST,
      dialogPayment: false,
      saving: false,
      paymentForm: {
        Amount: 0,
        Status: 2,
        Type: 2,
        Note: ''
      },
      paymentTypes: [
        { value: 2, name: 'Cọc đơn' },
        { value: 9, name: 'Thanh toán' }
      ],
      paymentMethods: [
        { value: 2, name: 'Ví điện tử' }
      ]
    };
  },
  filters: {
    payment_method(value) {
      return value == 1 ? "Trực tiếp" : "Ví điện tử";
    }
  },
  methods: {
    get_type_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    openDialog() {
      this.paymentForm = {
        Amount: 0,
        Status: 2,
        Type: 2,
        Note: ''
      };
      this.dialogPayment = true;
    },
    closeDialog() {
      this.dialogPayment = false;
    },
    savePayment() {
      const amount = parseFloat(this.paymentForm.Amount.toString().replace(/[^\d.-]/g, ''));
      if (!amount || amount <= 0) {
        sendErrorNotice("Vui lòng nhập số tiền hợp lệ!");
        return;
      }
      this.saving = true;
      const headers = request_header(this.$store.state.authentication.token);
      const payload = {
        Amount: amount,
        Status: this.paymentForm.Status,
        Type: this.paymentForm.Type,
        Note: this.paymentForm.Note
      };
      this.$http
        .post(`${configs.API || ""}/admin/api/main_order/create_payment/${this.order.ID}`, payload, { headers })
        .then(res => {
          this.saving = false;
          if (res.data.status === 200 || res.data.status === "success") {
            sendSuccessNotice("Tạo thanh toán thành công!");
            this.dialogPayment = false;
            this.$emit("refresh-order");
          } else {
            sendErrorNotice(res.data.reason || "Lỗi tạo thanh toán!");
          }
        })
        .catch(err => {
          this.saving = false;
          sendErrorNotice((err.data && err.data.reason) || "Lỗi kết nối đến máy chủ!");
        });
    }
  }
};
</script>
